// extracted by mini-css-extract-plugin
export var centered = "_a-6";
export var flexible = "_a-5";
export var footer = "_a-k";
export var footerBorder = "_a-l";
export var header = "_a-c";
export var headerBorder = "_a-d";
export var headerDefault = "_a-g";
export var headerMedium = "_a-h";
export var headerPadding = "_a-e";
export var iconAndTitle = "_a-f";
export var large = "_a-4";
export var largePadding = "_a-a";
export var medium = "_a-3";
export var mediumPadding = "_a-9";
export var modal = "_a-0";
export var modalContainer = "_a-b";
export var noPadding = "_a-7";
export var skinny = "_a-1";
export var small = "_a-2";
export var smallPadding = "_a-8";
export var subtitle = "_a-j";
export var title = "_a-i";